/** @typedef {{ id: string, url?: string|null, path?: string|null, preview?: string, fileName?: string, uploading?: boolean, error?: string }} WritingCheckerMediaItem */

export const WRITING_CHECKER_MAX_PHOTOS = 3;
export const WRITING_CHECKER_MAX_PHOTO_BYTES = 8 * 1024 * 1024;
export const WRITING_CHECKER_MAX_AUDIO = 3;
export const WRITING_CHECKER_MAX_AUDIO_BYTES = 15 * 1024 * 1024;

/** URLs ready for API / DB (upload finished, no error). */
export function getUploadedImageUrls(items) {
    return (items || [])
        .filter((i) => i.url && !i.uploading && !i.error)
        .map((i) => i.url);
}

export function hasUploadingImages(items) {
    return (items || []).some((i) => i.uploading);
}

export function hasAnswerInput(answerText, answerImages, answerAudios = []) {
    return (
        !!(answerText || '').trim() ||
        getUploadedImageUrls(answerImages).length > 0 ||
        getUploadedImageUrls(answerAudios).length > 0
    );
}

export function hasUploadingMedia(...lists) {
    return lists.some((items) => hasUploadingImages(items));
}

/** Extract `media` bucket object path from a Supabase storage URL (sign/public/authenticated). */
export function extractMediaStoragePath(url) {
    if (!url || typeof url !== 'string') return null;
    // Scraper-import double-replace bug nested a full signed URL inside the object key:
    // .../media/exercises/scraper-import/TS-https://host/.../media/exercises/scraper-import/TS-uuid.png?token=a?token=b
    const nested = url.match(
        /-https?:\/\/[^/\s"'<>]+\/storage\/v1\/object\/(?:sign|public|authenticated)\/media\/([^?\s"'<>]+)/i
    );
    if (nested?.[1]) return decodeURIComponent(nested[1]);
    const match = url.match(
        /\/storage\/v1\/object\/(?:sign|public|authenticated)\/media\/([^?]+)/i
    );
    if (!match?.[1]) return null;
    const path = decodeURIComponent(match[1]);
    // Refuse paths that still embed a nested http(s) URL
    if (/https?:\/\//i.test(path)) return null;
    return path;
}

export function revokeImagePreviews(items) {
    (items || []).forEach((i) => {
        if (i.preview) {
            try {
                URL.revokeObjectURL(i.preview);
            } catch {
                /* ignore */
            }
        }
    });
}
